import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const joinGroup = createAsyncThunk<void, string, { state: RootState }>(
  'groups/join',
  async (groupId, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    const updatedGroup = await groupsService.joinGroup({
      groupId,
    });

    dispatch(entitiesActions.upsertGroup(updatedGroup));
  },
);
